module.exports = __webpack_public_path__ + "static/img/3.7ea480e8.jpg";